import React, { Component } from 'react';
import { Virtual } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { getTextureUrl } from '../../Common/TextureTools';

import './lodging-selector.css';
import { ASSETS_URL } from '../../../../Settings';


export default class LodgingSelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            highlight: false,
            highlightedIndexes: [],
            lodgingCallback: null
        };
    }

    componentDidMount() {
        window.addEventListener(
            'highlight-lodging-event', this.highlightEvent);
        window.addEventListener(
            'clear-lodging-highlight-event', this.resetLodging);
    }


    componentWillUnmount() {
        window.removeEventListener(
            'highlight-lodging-event', this.highlightEvent);
        window.removeEventListener(
            'clear-lodging-highlight-event', this.resetLodging);
    }


    roomImage = (props) => {
        return <div>
            <img
                src={getTextureUrl(props.texture)}
                alt="room"
                className={'lodging-selector-image'}
            />
            {this.state.highlightedIndexes.includes(props.index) &&
                <div className={'lodging-selector-highlighter'}/>}
        </div>;
    };

    onClick = (swiper) => {
        console.log(swiper.clickedIndex);
        if (this.state.highlight) {
            if (this.state.lodgingCallback) {
                this.state.lodgingCallback(swiper.clickedIndex);
                this.resetLodging();
            }
        }
    };

    resetLodging = () => {
        this.setState({
            highlight: false,
            highlightedIndexes: [],
            lodgingCallback: null
        });
    };


    highlightEvent = (e) => {
        this.highlightLodging(e.detail.indexes, e.detail.callback);
    }

    highlightLodging = (highlightedIndexes, callback) => {
        this.setState({
            highlight: true,
            highlightedIndexes: highlightedIndexes,
            lodgingCallback: callback
        });
    };


    render() {
        // let className = 'inventory-selector-swiper-container';
        // if (this.state.highlight && highlightStorageArea) className += ' inventory-animated-border-dashed';

        return (
            <div className={'lodging-selector'}>
                <div className={'lodging-selector-container'}>
                    <div className={'lodging-selector-swiper-container'}>
                        <Swiper
                            slidesPerView={6}
                            spaceBetween={0}
                            freeMode={true}
                            grabCursor={true}

                            modules={[ Virtual ]}

                            onSwiper={(swiper) => {
                                this.swiper = swiper;
                            }}
                            onClick={this.onClick}
                            className="action-scroller-swiper"
                        >
                            {this.props.gamePlayerData.lodging.map((gridItem, index) => {
                                return <SwiperSlide key={`gi-${index}`}
                                                    virtualIndex={index}>
                                    <this.roomImage texture={gridItem}
                                                    highlightedIndexes={this.state.highlightedIndexes}
                                                    index={index}
                                    />
                                </SwiperSlide>;
                            })}
                        </Swiper>
                    </div>
                    <img
                        src={`${ASSETS_URL}overlays/LodgingOverlay-1080x210.png`}
                        alt="action"
                        className={'swiper-overlay'}
                    />
                </div>

            </div>
        );
    }
}
